module.exports = __webpack_public_path__ + "static/media/error.6fa38d0a.png";